import React, { ButtonHTMLAttributes, memo } from "react";

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: any;
  className?: any;
}

const Button = ({ children, className, ...restProps }: IButton) => {
  return (
    <button
      className={`w-40 h-14 px-2 py-5 justify-center items-center rounded-lg text-2xl font-semibold font-sourceSansPro transition duration-300 hover:ease-in filter hover:brightness-90 ${className}`}
      {...restProps}
    >
      {children}
    </button>
  );
};

export default memo(Button);
